'use client';

import { createIcon } from './utils';

import type { TSVGIcon } from './interface';

export const CloseIcon: TSVGIcon = createIcon({
  displayName: 'CloseIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M19 5 5 19M5 5l4.5 4.5M12 12l7 7'
    />
  ),
});
